// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2BHdT","item":"PaymentsMobile_item__1E-yS","label":"PaymentsMobile_label__1TBMQ","amount":"PaymentsMobile_amount__2P6q4"};